import authLogic from "./auth/authLogic";

export default [
  ...authLogic
]
